import { ReactNode, forwardRef } from 'react';

import { headingRecipe } from './Heading.css';
import type { HeadingVariants } from './Heading.css';
import { getClassNames } from '../../util/css';

const sparkyClassName = 'sparky-heading';

export interface HeadingProps extends HeadingVariants {
  /** The DOM element to render */
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

  /** For usage with ARIA attributes */
  id?: string;
  className?: never;
  children: ReactNode;
}

export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ size = 'XL', as: Tag = 'h1', color = 'textPrimary', children, className = '', id }, ref) => {
    const classNames = getClassNames(sparkyClassName, headingRecipe({ size, color }), className);
    return (
      <Tag className={classNames} id={id} ref={ref}>
        {children}
      </Tag>
    );
  },
);

Heading.toString = () => `.${sparkyClassName}`;
Heading.displayName = 'Heading';
